/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Buy_NowInputs */

const vi_pos_buy_now = /** @type {(inputs: Pos_Buy_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bán ngay`)
};

/**

* @param {Pos_Buy_NowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_buy_now = /** @type {((inputs?: Pos_Buy_NowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Buy_NowInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_buy_now(inputs)
});